import React from 'react';
import {
  CardCVCElement,
  CardElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  injectStripe,
  StripeProvider
} from "react-stripe-elements";
import config from '../../config';
import {Form, Formik} from 'formik';
import fetch from 'cross-fetch';
import Field from "../../shared/forms/Field";
import styled from 'styled-components';


const cardElementInternalStyle = {
  base: {
    fontSize: '18px',
    lineHeight: '30px',
    padding: '10px 20px',
  }
};

const InlineFields = styled.div`
  display: flex;
  margin: -5px;
  > * {
    width: 50%;
    padding: 5px;
  }
`;

const CustomField = styled(Field)``;

const CustomForm = styled(Form)`
  ${CustomField} {
    margin-bottom: 20px;
  }
`;


class DepositForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null
    };
  }

  handleSubmit = (values, actions) => {
    window.analytics.track("Shift - Clicked Top Up Deposit", {phone: this.props.phone});
    actions.setSubmitting(true);
    this.props.stripe.createToken({name: values.name}).then(({token}) => {
      if (!token) {
        this.setState({
          status: 'INVALID'
        });
        actions.setSubmitting(false);
        return;
      }
      console.log('Received Stripe token:', token);

      fetch(config.apiRoot + '/pros/stripe_by_phone/', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          phone: this.props.phone,
          token: token.id,
        })
      }).then(response => response.json().then((pro) => {
        console.log(pro);
        actions.setSubmitting(false);
        this.props.onComplete();
      }));
    });
  };

  render() {
    return (
      <Formik
        onSubmit={this.handleSubmit}
        initialValues={{
          name: '',
        }}
      >
        {({isSubmitting, isValid}) => (
          <CustomForm>
            <CustomField label={'Name'} name={'name'}/>
            <CustomField label={'Credit Card Number'}>
              <CardNumberElement style={cardElementInternalStyle}/>
            </CustomField>
            <InlineFields>
              <CustomField label={'Expiry Date'}>
                <CardExpiryElement style={cardElementInternalStyle}/>
              </CustomField>
              <CustomField label={'CVC'}>
                <CardCVCElement style={cardElementInternalStyle}/>
              </CustomField>
            </InlineFields>
            {this.state.status === 'INVALID' && (
              <div>Your card is invalid</div>
            )}
            <button
              className="btn btn-primary btn-block btn-pointer"
              disabled={isSubmitting || !isValid} type={'submit'}>Top Up</button>
          </CustomForm>
        )}
      </Formik>
    );
  }
}

DepositForm = injectStripe(DepositForm);

const DepositFormWithProvider = ({phone, onComplete, ...props}) => (
  <StripeProvider apiKey={config.stripeKey}>
    <Elements>
      <DepositForm {...props} phone={phone} onComplete={onComplete}/>
    </Elements>
  </StripeProvider>
);

export default DepositFormWithProvider;



// WEBPACK FOOTER //
// ./src/pages/shift-page/DepositForm.js